<div class="watchlist-container">
  <app-title-container>
    <h1>Watchlist Country/Sector</h1>
  </app-title-container>

  <div class="first-actions-container">
    <mat-button-toggle-group [formControl]="criticalScopeControl" aria-label="Font Style">
      <mat-button-toggle [value]="true">Critical human rights</mat-button-toggle>
      <mat-button-toggle [value]="false">All</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <app-divider height="2px"></app-divider>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div class="watchlist-text-content">
      <span>{{ countrySectorMainTexts().description }}</span>
      <span class="material-symbols-outlined action-icon" [matTooltip]="countrySectorMainTexts().descriptionTooltip"> info </span>
    </div>

    <div class="second-actions-container">
      @if (isCriticalScope()) {
        <button
          class="helper-text"
          (click)="helperPreviewOpened.set(!helperPreviewOpened())"
          type="button"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
        >
          <span class="material-symbols-outlined"> help </span> Table Helper
        </button>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="helperPreviewOpened()"
          (overlayOutsideClick)="helperPreviewOpened.set(false)"
          [cdkConnectedOverlayOffsetX]="22"
          [cdkConnectedOverlayOffsetY]="-25"
          [cdkConnectedOverlayPositions]="[
            {
              originX: 'start',
              originY: 'bottom',
              overlayX: 'start',
              overlayY: 'top',
            },
          ]"
        >
          <div class="info-overlay">
            <app-watchlist-country-sector-helper [helperTexts]="countrySectorHelperTexts()"></app-watchlist-country-sector-helper>
          </div>
        </ng-template>
      }

      <button class="clickable-text-btn ml-auto" (click)="exportExcel()" [disabled]="isLoadingExport()" aria-label="Export to Excel">
        @if (isLoadingExport()) {
          <mat-icon class="clickable-text-btn-icon"><mat-spinner diameter="15"></mat-spinner></mat-icon>
        } @else {
          <mat-icon fontSet="material-symbols-outlined" class="clickable-text-btn-icon"> file_export </mat-icon>
        }

        Export to Excel
      </button>
    </div>

    <div class="table-container">
      <app-watchlists-table
        [colDefs]="countrySectorColumnDefs()"
        [rowData]="countrySectorResponse()?.countrySectorData ?? []"
        [pagination]="false"
        (rowClicked)="onRowClicked($event)"
      ></app-watchlists-table>
    </div>
    <div class="watchlist-text-content">
      <span>{{ countrySectorMainTexts().tableNote }}</span>
    </div>
  }
</div>
